<template>
  <div id="tempStaffBilling">
    <div class="content-body-container">
      <div style="text-align: left">
        <h3>Invoice List</h3>

        <div class="temp-invoice-list-container" v-if="invoiceList.length > 0">
          <data-tables :data="invoiceList" :action-col="invoiceListAction">
            <el-table-column v-for="item in invoiceListTable" min-width="50px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
'use strict'
import DataSource from '../data/datasource'
import $ from 'jquery'
import Cookies from 'js-cookie'
import { lang } from '../locale/index'

export default {
  name: 'TempStaffBilling',
  components: {},
  data() {
    return {
      invoiceList: [],
      invoiceListTable: [
        {
          prop: 'IH_Invoice_Name',
          label: lang('Invoice Name'),
        },
        {
          prop: 'IH_Invoice_Date_Convert',
          label: lang('Invoice Date'),
        },
        {
          prop: 'TotalAmountIncGst',
          label: lang('Invoice Amount'),
        },
        {
          prop: 'OutstandingAmount',
          label: lang('Outstanding Amount'),
        },
        {
          prop: 'IH_Remarks',
          label: lang('Remarks'),
        },
      ],

      invoiceListAction: {
        label: lang('Action'),
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'fa fa-credit-card', // el-credit-card, el-icon-info
            },

            handler: row => {
              if (row.EncryptedId) {
                let decodedEncryptedId = decodeURI(row.EncryptedId)

                let routeData = this.$router.resolve('/Public/Payment?ID=' + decodedEncryptedId)
                window.open(routeData.href, '_blank')
              }
            },
            label: '',
          },
        ],
      },
    }
  },
  created() {
    this.getInvoiceListTemp()
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    $(window).unbind('scroll')
    window.removeEventListener('resize', this.isMobile)
  },
  methods: {
    lang,

    isNull(obj) {
      return obj === null || obj === undefined || obj === 'undefined' || obj.length === 0 || obj === ''
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },

    sleep(milliseconds) {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
    },

    async getInvoiceListTemp() {
      this.$vs.loading()

      try {
        this.invoiceList = []

        const response = await DataSource.shared.getInvoicListPT('invoice', 'STU202000143546')
        if (response.Table) {
          if (response.code === '2') {
            console.log('No record found')
          } else if (response.code === '99') {
            console.log('99')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.invoiceList = response.Table ? response.Table : []
          }
        }

        this.$vs.loading.close()
      } catch (e) {
        console.log(e)
      }
    },
  },
  mounted() {
    const self = this
    self.isMobile()
  },
  computed: {},
}
</script>

<style scoped>
.content-body-container {
  padding: 20px;
  margin: 0 auto;
}
</style>
